var BrowserAdapter = {
  createCanvas: function createCanvas(width, height) {
    var canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas;
  },
  getWebGLRenderingContext: function getWebGLRenderingContext() {
    return WebGLRenderingContext;
  },
  getNavigator: function getNavigator() {
    return navigator;
  },
  getBaseUrl: function getBaseUrl() {
    var _document$baseURI;
    return (_document$baseURI = document.baseURI) !== null && _document$baseURI !== void 0 ? _document$baseURI : window.location.href;
  },
  getFontFaceSet: function getFontFaceSet() {
    return document.fonts;
  },
  fetch: function (_fetch) {
    function fetch(_x, _x2) {
      return _fetch.apply(this, arguments);
    }
    fetch.toString = function () {
      return _fetch.toString();
    };
    return fetch;
  }(function (url, options) {
    return fetch(url, options);
  }),
  parseXML: function parseXML(xml) {
    var parser = new DOMParser();
    return parser.parseFromString(xml, "text/xml");
  }
};
export { BrowserAdapter };